<template>
  <div>
  </div>
</template>

<script>
import {RadioButton, RadioGroup} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'

export default {
  components: {
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup
  },
  props: [],
  mixins: [TranslationsUtils],
  data () {
    return {
      model: {
        social_security_number: '',
        primary_insurance: '',
        primary_insurance_name_input: '',
        policy_number: '',
        group_number: '',
        relationship: '',
        insured_first_name: '',
        insured_last_name: '',
        insured_date_of_birth: '',
        insured_date_of_birth_pretty: '',
        insured_address_components: '',
        insured_gender: '',
        insurance_card_images: [],
        insurance_card_names: [],
        error_uninsured: '',
        note: ''
      }
    }
  },
  beforeMount () {
    this.$emit('validateBill', true)
    this.populateModel('client_bill')
  },
  methods: {
    validate () {
      return true
    },
    resetAddressObject () {
      let resetAddress = {
        name: '',
        original_name: '',
        delivery_line_1: '',
        city_name: '',
        county: '',
        state_abbreviation: '',
        zipcode: '',
        plus4_code: '',
        county_fips: '',
        country: ''
      }
      return resetAddress
    },
    populateModel (type) {
      this.model.primary_insurance = type
      this.model.policy_number = type
      this.model.group_number = type
      this.model.insurance_card_image = ''
      this.model.social_security_number = ''
      this.model.relationship = 'Self'
      this.model.insured_first_name = this.$store.state.insuranceData.firstName
      this.model.insured_last_name = this.$store.state.insuranceData.lastName
      this.model.insured_date_of_birth = this.$store.state.insuranceData.dob
      this.model.insured_date_of_birth_pretty = this.$store.state.insuranceData.dob_pretty
      this.model.insured_gender = this.$store.state.insuranceData.gender
      this.model.insured_address_components = this.$store.state.insuranceData.addressComponents || this.resetAddressObject()
      this.model.insured_address2 = this.$store.state.insuranceData.address2
    }
  },
  watch: {
    'model': {
      handler: function (value) {
        this.$emit('updateModel', this.model)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/BillParts/ClientBill.vue